import { evaluation360 } from '../../i18n/translatedMessages'

export function Pills({ finished }) {
	if (finished)
		return (
			<div className='tw-px-4  tw-py-1 tw-text-center tw-bg-gray-900 tw-text-white tw-rounded-full tw-inline-flex '>
				{evaluation360.evaluationFinshed}
			</div>
		)
	return (
		<div className='tw-px-3  tw-py-1 tw-text-center tw-bg-[#DFF3FE] tw-text-green-800 tw-rounded-full tw-inline-flex '>
			{evaluation360.evaluationInProgress}
		</div>
	)
}
